import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Select from "react-select";
import * as codeActions from "../../../actions/codeActions";

const PtoRequestStatusSelect = ({
  value: initialValue,
  isMulti = false,
  onChange,
  codes = [],
  actions,
  disabled,
  loading,
  defaultValues
}) => {
  if (!codes.length) {
    actions.loadCodes();
  }

  const options = codes
    .filter((code) => code.entity === "PTO Request" && code.field === "status")
    .map((d) => ({
      label: d.label,
      value: d._id,
      order: d.order
    }));

  useEffect(() => {
    if (
      defaultValues &&
      disabled &&
      !initialValue &&
      isMulti &&
      options &&
      Array.isArray(options) &&
      options.length > 0
    ) {
      const values = options.filter((o) =>
        defaultValues.find((dV) => parseInt(dV) === parseInt(o.order))
      );
      onChange(values);
    }
  }, [defaultValues, initialValue, isMulti, onChange, options, disabled]);

  const value =
    isMulti && Array.isArray(initialValue)
      ? options.filter((x) => initialValue.includes(x.value))
      : initialValue || [];

  return (
    <Select
      id="pto-request-status-type-select"
      className="react-select-container"
      classNamePrefix="react-select-container"
      fullwidth
      placeholder="Status"
      value={value}
      options={options}
      isClearable
      onChange={onChange}
      isMulti={isMulti}
      isDisabled={disabled}
      isLoading={loading}
    />
  );
};

PtoRequestStatusSelect.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  codes: PropTypes.array,
  actions: PropTypes.object,
  isMulti: PropTypes.bool,
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  defaultValues: PropTypes.array
};

PtoRequestStatusSelect.defaultProps = {
  disabled: false,
  loading: false,
  defaultValues: null
};

function mapStatesToProps(state) {
  return {
    codes: state.reducers.codes
  };
}
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        ...codeActions
      },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(PtoRequestStatusSelect);
